import { Button, Checkbox, DatePicker, Input, TableColumnsType } from 'antd'
import Axios from 'axios'
import moment from 'moment'
import React from 'react'
import { useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Badge from '../../component/badge'
import ExpandedRow from '../../component/expandedRow'
import Table from '../../component/table'

const { RangePicker } = DatePicker

const columns: TableColumnsType = [
    {
        title: 'Title',
        dataIndex: 'title',
        sorter: (a: any, b: any) => (a.title > b.title ? -1 : 1),
    },
    {
        title: 'Installed',
        dataIndex: 'installed',
        filters: [
            {
                text: 'Yes',
                value: 'yes',
            },
            {
                text: 'No',
                value: 'no',
            },
        ],
        filterMultiple: true,
        onFilter: (value: string | number | boolean, record: any) => record.installed.indexOf(value) === 0,
    },
    {
        title: 'Platform',
        dataIndex: 'platform',
        filters: [
            {
                text: 'Lora',
                value: 'lora',
            },
            {
                text: 'Onenet',
                value: 'onenet',
            },
        ],
        filterMultiple: true,
        onFilter: (value: string | number | boolean, record: any) => record.platform.indexOf(value) === 0,
    },
    {
        title: 'Battery',
        dataIndex: 'voltage',
    },
    {
        title: 'Records',
        dataIndex: 'record',
        render: (record: any) => {
            return (
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>00:00</th>
                            <th>01:00</th>
                            <th>02:00</th>
                            <th>03:00</th>
                            <th>04:00</th>
                            <th>05:00</th>
                            <th>06:00</th>
                            <th>07:00</th>
                            <th>08:00</th>
                            <th>09:00</th>
                            <th>10:00</th>
                            <th>11:00</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>AM</td>
                            {renderRecord(record, 0, 12)}
                        </tr>
                        <tr>
                            <td>PM</td>
                            {renderRecord(record, 12, 24)}
                        </tr>
                    </tbody>
                </table>
            )
        },
    },
]

const renderRecord = (record: [], start: number, end: number) => {
    const children: Array<any> = []
    for (let i = start; i < end; i++) {
        children.push(
            <td key={`${start}-${i}`}>
                <Badge title={i.toString()} type={record[i] > 0 ? 'success' : 'fail'}>
                    {record[i]}
                </Badge>
            </td>
        )
    }
    return children
}

interface IProps extends RouteComponentProps {}

const HistoryList: React.FC<IProps> = (props) => {
    const [state, setState] = React.useState({
        date: [moment(), moment().add({ days: 1 })] as [moment.Moment, moment.Moment],
        platform: '',
        district: [],
        contains: '',
        loading: false,
        data: [] as any[],
    })
    const [pageIndex, setPageIndex] = React.useState(1)
    const [totalPage, setTotalPage] = React.useState(0)

    function getDevicesData(): any {
        Axios.get('/devices/data', {
            params: {
                start: state.date[0].format('YYYY-MM-DD'),
                end: state.date[1].format('YYYY-MM-DD'),
                platform: state.platform,
                district: state.district,
                contains: state.contains,
                pageIndex,
            },
        })
            .then((res) => {
                const convert: Array<any> = []
                res.data.val.forEach((row: any, index: number) => {
                    let records: Array<number> = new Array<number>(24).fill(0)
                    row.records.forEach((element: any) => {
                        const local = moment(element.recordedAt)
                        records[local.toDate().getHours()] += 1
                    })

                    const latest = row.records[row.records.length - 1]
                    convert.push({
                        title: row.title,
                        platform: row.platform,
                        record: records,
                        installed: row.installed,
                        key: index,
                        latest: latest ? latest : undefined,
                        DEUI: row.deviceId,
                        deviceId: row.deviceId,
                        voltage: latest ? latest.voltage : undefined,
                        APP_KEY: row.APP_KEY,
                        APP_EUI: row.APP_EUI,
                    })
                })

                setState((prev) => ({ ...prev, data: convert }))

                setTotalPage(res.data.totalDevices)
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setState((prev) => ({ ...prev, loading: false }))
            })
    }

    const onSubmit = () => {
        setState((prev) => ({ ...prev, loading: true }))
        getDevicesData()
    }

    const handleReset = () => {
        setState((prev) => ({
            ...prev,
            date: [moment(), moment().add({ days: 1 })],
            platform: '',
            district: [],
            contains: '',
        }))
    }

    const onChange = (date: any, dateString: any) => {
        setState((prev) => ({
            ...prev,
            date: date,
        }))
    }

    const getData = () => state.data

    const renderExpandedRow = (record: any) => {
        return <ExpandedRow record={record} />
    }

    const onPlatformTick = (e: any) => {
        const value = e.target.value
        setState((prev) => ({
            ...prev,
            platform: state.platform !== value ? value : '',
        }))
    }

    const onInputChange = (evt: any) => {
        const value = evt.target.value
        setState((prev) => ({ ...prev, district: value.split(',') }))
    }

    const changePageData = (page: number) => {
        setPageIndex(page)
    }

    useEffect(() => {
        if (totalPage) {
            setState((prev) => ({ ...prev, loading: true }))
            getDevicesData()
        }
    }, [pageIndex])

    return (
        <>
            <div>
                <table style={{ lineHeight: '40px' }}>
                    <tbody>
                        <tr>
                            <td align="right">Date Range: </td>
                            <td align="left">
                                <RangePicker onChange={onChange} value={state.date} />
                            </td>
                        </tr>
                        <tr>
                            <td align="right">Platform: </td>
                            <td align="left">
                                {' '}
                                <Checkbox checked={state.platform === 'lora'} onChange={onPlatformTick} value="lora">
                                    Lora
                                </Checkbox>
                                <Checkbox
                                    checked={state.platform === 'onenet'}
                                    value="onenet"
                                    onChange={onPlatformTick}
                                >
                                    Onenet
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">District: </td>
                            <td align="left">
                                <Input
                                    placeholder="Select district"
                                    // mode="multiple"
                                    onChange={onInputChange}
                                    style={{ width: '100%' }}
                                    value={state.district}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td align="left">Sensor ID Contains</td>
                            <td>
                                <Input
                                    value={state.contains}
                                    onChange={(e) => {
                                        const v = e.target.value
                                        setState((prev) => ({ ...prev, contains: v }))
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td align="center" colSpan={2}>
                                <Button type="primary" htmlType="submit" onClick={onSubmit}>
                                    Search
                                </Button>
                                <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                                    Clear
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{ marginTop: '50px' }}>
                <Table
                    columns={columns}
                    data={getData()}
                    expandedRowRender={renderExpandedRow}
                    loading={state.loading}
                    pagination={{ onChange: changePageData, total: totalPage }}
                />
            </div>
        </>
    )
}

export default HistoryList
